import Gregorian_Date from "./Gregorian_Date";
import Gregorian_Datetime from "./Gregorian_Datetime";
import Hour_Time from "./Hour_Time";

const milliseconds_in_a_day = 86400000; // 1000 * 60 * 60 * 24;
const seconds_in_a_day = 86400; // 1000 * 60 * 60 * 24;
/*
  Corno:
  the number 2440587 is correct, it should not be 2440587.5 as we want days to change at midnight.
*/
const difference_between_day_0_of_unix_and_day_0_of_julian = 2440587;
const difference_in_seconds_between_day_0_of_unix_and_day_0_of_julian =
	difference_between_day_0_of_unix_and_day_0_of_julian * seconds_in_a_day;
const milliseconds_in_a_second = 1000;

export function gregorian_date_2_julian_date(gregorian_date: Gregorian_Date): number {
	const js_date = Date.UTC(gregorian_date.getYear(), gregorian_date.getMonth() - 1, gregorian_date.getDay());
	return Math.floor(js_date / milliseconds_in_a_day + difference_between_day_0_of_unix_and_day_0_of_julian);
}

export function gregorian_datetime_2_julian_datetime(gregorian_datetime: Gregorian_Datetime): number {
	const elapsed_unix_seconds =
		new Date(
			gregorian_datetime.getDate().getYear(),
			gregorian_datetime.getDate().getMonth() - 1,
			gregorian_datetime.getDate().getDay(),
			gregorian_datetime.getTime().getHour(),
			gregorian_datetime.getTime().getMinute(),
			gregorian_datetime.getTime().getSecond()
		).getTime() / milliseconds_in_a_second;
	return elapsed_unix_seconds + difference_in_seconds_between_day_0_of_unix_and_day_0_of_julian;
}

export function parseHtmlDate(value: string): Date | undefined {
	const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
	if (match === null) {
		return undefined;
	}
	const matches = match
		.slice(1) //skip the whole regex match
		.map(function (s) {
			return s === undefined ? 0 : Number(s);
		}); //convert the strings to numbers.
	const parsedDate = new Date(matches[0], matches[1] - 1, matches[2], matches[3], matches[4], matches[5]);
	return new Date(parsedDate.getTime());
}

export function jstimestamp_2_julian_datetime(timestamp: number): number {
	return (
		Math.floor(timestamp / milliseconds_in_a_second) + difference_in_seconds_between_day_0_of_unix_and_day_0_of_julian
	);
}

export function jsdate_2_julian_datetime(jsdate: Date): number {
	return jstimestamp_2_julian_datetime(jsdate.getTime());
}

export function jsdate_2_julian_date(jsdate: Date): number {
	return Math.floor(
		(jsdate.getTime() - jsdate.getTimezoneOffset() * 60 * 1000) / milliseconds_in_a_day +
			difference_between_day_0_of_unix_and_day_0_of_julian
	);
}

export function julian_date_2_gregorian_date(julian_date: number): Gregorian_Date {
	const date = new Date((julian_date - difference_between_day_0_of_unix_and_day_0_of_julian) * milliseconds_in_a_day);
	return new Gregorian_Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export function julian_date_2_js_date(julian_date: number): Date {
	return new Date((julian_date - difference_between_day_0_of_unix_and_day_0_of_julian) * milliseconds_in_a_day);
}

export function julian_datetime_2_gregorian_datetime(julian_datetime: number): Gregorian_Datetime {
	const elapsed_unix_seconds = julian_datetime - difference_in_seconds_between_day_0_of_unix_and_day_0_of_julian;
	const date = new Date(elapsed_unix_seconds * milliseconds_in_a_second);

	return new Gregorian_Datetime(
		new Gregorian_Date(date.getFullYear(), date.getMonth() + 1, date.getDate()),
		new Hour_Time(date.getHours(), date.getMinutes(), date.getSeconds())
	);
}

export function julian_datetime_2_js_date(julian_datetime: number): Date {
	const elapsed_unix_seconds = julian_datetime - difference_in_seconds_between_day_0_of_unix_and_day_0_of_julian;

	return new Date(elapsed_unix_seconds * milliseconds_in_a_second);
}
